// shadcn registry item "@shadcn/kbd" (new-york-v4), from the pinned shadcn 4.21.4 in Shared-Tools/shadcn-mcp, 10/14/2026.
// Not in Repo/components/ui, so it lives in the v3 project only. Imports rewritten the way `shadcn add` does:
// cn → @/lib/utils (the site's own cn), radix-ui Slot → @radix-ui/react-slot, registry paths → @/components/ui.
import { cn } from "@/lib/utils"

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm bg-muted px-1 font-sans text-xs font-medium text-muted-foreground select-none",
        "[&_svg:not([class*='size-'])]:size-3",
        "[[data-slot=tooltip-content]_&]:bg-background/20 [[data-slot=tooltip-content]_&]:text-background dark:[[data-slot=tooltip-content]_&]:bg-background/10",
        className
      )}
      {...props}
    />
  )
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <kbd
      data-slot="kbd-group"
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    />
  )
}

export { Kbd, KbdGroup }
